module.exports = __webpack_public_path__ + "img/ico_rating_content_drug.48d6016c.png";